<template>
  <v-card>
    <GChart
        type="ColumnChart"
        :data="chartData"
        :options="chartOptions"
    />
  </v-card>
</template>

<script>
export default {
  name: 'ChartTrx',
  data: () => ({
    chartData: [
      ['Year', 'Trx'],
      ['2014', 100242],
      ['2015', 180242],
      ['2016', 120242],
      ['2017', 160242]
    ],
    chartOptions: {
      height: 400,
      title: 'Jumlah Transaksi',
      legend: { position: 'none' },
      chart: {
        legend: { position: 'top' },
        title: 'Company Performance',
        subtitle: 'Sales, Expenses, and Profit: 2014-2017'
      }
    }
  })
}
</script>

<style scoped>

</style>
